import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "data-prep-custom-transformation" }
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = { class: "p-float-label p-field p-ml-2 kn-flex" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { class: "p-float-label p-field p-ml-2 kn-flex" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = {
  key: 0,
  class: "p-float-label p-field p-ml-2 kn-flex"
}
const _hoisted_8 = { class: "kn-material-input-label" }
const _hoisted_9 = {
  key: 1,
  class: "p-float-label p-field p-ml-2 kn-flex"
}
const _hoisted_10 = { class: "kn-material-input-label" }
const _hoisted_11 = { class: "p-d-flex" }
const _hoisted_12 = { class: "p-float-label p-field p-ml-2 kn-flex" }
const _hoisted_13 = { class: "kn-material-input-label" }
const _hoisted_14 = { class: "p-d-flex" }
const _hoisted_15 = { class: "p-float-label p-field p-ml-2 kn-flex" }
const _hoisted_16 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Fieldset = _resolveComponent("Fieldset")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.localTransformation.column,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localTransformation.column = $event)),
          options: _ctx.getStringColumns(_ctx.columns),
          class: "kn-material-input",
          optionLabel: "fieldAlias",
          filter: true,
          disabled: _ctx.col || _ctx.readOnly
        }, null, 8, ["modelValue", "options", "disabled"]),
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.column')), 1)
      ]),
      _createVNode("span", _hoisted_5, [
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.localTransformation.condition,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localTransformation.condition = $event)),
          disabled: _ctx.readOnly,
          options: _ctx.availableConditions,
          optionLabel: _ctx.translatedLabel,
          optionValue: "code",
          class: "kn-material-input"
        }, null, 8, ["modelValue", "disabled", "options", "optionLabel"]),
        _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.conditions')), 1)
      ]),
      (_ctx.localTransformation.condition === 'numberOfChars')
        ? (_openBlock(), _createBlock("span", _hoisted_7, [
            _createVNode(_component_InputText, {
              type: "number",
              modelValue: _ctx.localTransformation.numOfChars,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.localTransformation.numOfChars = $event)),
              disabled: _ctx.readOnly,
              class: "kn-material-input"
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.numOfChars')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.localTransformation.condition === 'separator')
        ? (_openBlock(), _createBlock("span", _hoisted_9, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.localTransformation.separator,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.localTransformation.separator = $event)),
              disabled: _ctx.readOnly,
              class: "kn-material-input"
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.workspaceManagement.dataPreparation.transformations.separator')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Fieldset, {
      legend: _ctx.$t('managers.workspaceManagement.dataPreparation.transformations.split.outputColumn') + ' 1'
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_11, [
          _createVNode("span", _hoisted_12, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.localTransformation.outputColumn1,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.localTransformation.outputColumn1 = $event)),
              disabled: _ctx.readOnly,
              class: "kn-material-input"
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.name')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["legend"]),
    _createVNode(_component_Fieldset, {
      legend: _ctx.$t('managers.workspaceManagement.dataPreparation.transformations.split.outputColumn') + ' 2'
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.localTransformation.outputColumn2,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.localTransformation.outputColumn2 = $event)),
              disabled: _ctx.readOnly,
              class: "kn-material-input"
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('common.name')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["legend"])
  ]))
}